import { render, staticRenderFns } from "./appraisalDetail.vue?vue&type=template&id=d5a13abc&"
import script from "./appraisalDetail.vue?vue&type=script&lang=js&"
export * from "./appraisalDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports